import { createFileRoute } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { PageShell } from "@/components/site/PageShell";

export const Route = createFileRoute("/$lang/shop")({
  head: ({ params }) => ({
    meta: [
      { title: "Shop — MadCaptains" },
      { name: "robots", content: "noindex" },
      { property: "og:url", content: `/${params.lang}/shop` },
    ],
    links: [{ rel: "canonical", href: `/${params.lang}/shop` }],
  }),
  component: ShopPage,
});

function ShopPage() {
  const { t } = useI18n();
  return (
    <PageShell eyebrow="Coming in v2" title={t.page_shop_h1} lead={t.page_shop_soon}>
      <p className="text-sm text-muted-foreground">
        Print-on-demand only. Margin goes to the project. Commerce will never be injected into the story-reading flow.
      </p>
    </PageShell>
  );
}